import { Button, Flex, Text } from '@gjensidige/builders-components';

import './Confirmation.scss';
import { TravelHeader } from '../../components/TravelHeader/TravelHeader';

export const Confirmation = () => {
  return (
    <Flex center="lg" layout={1}>
      <TravelHeader caption="the claim is sent" headerTitle="Thanks for reporting your claim" />
      <Text size="body">A claim handler will review your claim and get back to you by email.</Text>
      <Text size="body" className="middle-text">
        Claims are normally handled within 5 days. Peak seasons, e.g. summer holidays, can
        temporarily lead to an extended turnaround time.
      </Text>
      <Text size="body" className="bottom-text">
        We have everything we need at this moment, but please keep in mind that we might ask for
        more information when reviewing your claim.
      </Text>
      <Button
        variant="action"
        arrow="left"
        href="https://www.gjensidige.no/meld-skade/privat/reise/claims-equinor-eng"
      >
        Back
      </Button>
    </Flex>
  );
};
